import styled from 'styled-components';
import { rgba } from 'polished';

export const defaultBoxShadow = `0 3px 6px ${rgba('#000', 0.15)}`;

export const ImageBox = styled.div`
	background-color: #d5d5d5;
	box-shadow: ${({ boxShadow }) =>
		boxShadow ? boxShadow : `0 3px 10px ${rgba('#1C2550', 0.15)}`};
`;

// Player styles
export const AudioTimeline = styled.div`
	background-color: ${({ bgColor }) => bgColor || `#fff`};
`;

export const ProgressLoaded = styled.div`
	background-color: ${({ bgColor }) => bgColor || `${rgba('#ec5d24', 0.4)}`};
`;

export const ProgressThumb = styled.div`
	background-color: ${({ bgColor }) => bgColor || '#ec5d24'};
	box-shadow: ${({ boxShadow }) =>
		boxShadow ? boxShadow : defaultBoxShadow};
`;

export const ProgressValue = styled.div`
	background-color: ${({ bgColor }) => bgColor || '#ec5d24'};
`;

// React Select Shared Styles
export const selectStyles = {
	container: () => ({
		position: 'relative'
	}),
	control: () => ({
		height: 40,
		display: 'flex',
		alignItems: 'center',
		fontSize: 13,
		backgroundColor: '#fff',
		border: '1px solid',
		borderRadius: 3,
		cursor: 'pointer'
	}),
	menu: () => ({
		position: 'absolute',
		top: 50,
		right: 0,
		left: 0,
		zIndex: 109,
		width: '100%',
		backgroundColor: '#fff',
		borderRadius: 5,
		boxShadow: '0 3px 6px rgba(0,0,0,0.15)'
	}),
	menuList: () => ({
		fontSize: 2,
		borderRadius: 5
	}),
	valueContainer: () => ({
		display: 'inline-flex',
		alignItems: 'center',
		flex: 1,
		paddingRight: 10,
		paddingLeft: 10,
		position: 'relative',
		overflow: 'hidden',
		height: '100%'
	}),
	singleValue: () => ({
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	}),
	option: () => ({
		position: 'relative',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		padding: '5px 15px',
		height: 40,
		fontSize: 13,
		':not(:last-child)': {
			borderBottom: '1px solid #c9cdd9'
		}
	}),
	indicatorsContainer: () => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 40,
		width: 35,
		color: '#838794',
		transition: 'color 0.35s'
	})
};
